export default __webpack_public_path__ + "static/media/landing.36aba12d.png";